import { Grid, Typography } from '@mui/material'
import { styled } from '@mui/system'
import Button from '../../button'
import Link from '../../link'
import { WorkingTimes as BHWorkingTimes } from '../list'

const shouldForwardProp = (prop) => !['hasImages'].includes(prop)

const BackButton = styled(Link)`
	position: relative;
	z-index: 1;
	display: flex;
	align-items: center;
	line-height: 1;
	padding: ${({ theme }) => theme.spacing(3)};
	> .MuiSvgIcon-root {
		margin-right: ${({ theme }) => theme.spacing(1)};
	}
	${({ theme }) => theme.breakpoints.up('lg')} {
		margin-top: ${({ theme }) => theme.spacing(-1)};
		padding: 0;
	}
`

const Content = styled(Grid)`
	padding: ${({ theme }) => theme.spacing(4, 3, 3)};
`

const GetDirection = styled(Button)`
	margin-top: ${({ theme }) => theme.spacing(3)};
`

const InnerContent = styled(Grid, { shouldForwardProp })`
	${({ theme }) => theme.breakpoints.up('lg')} {
		${({ hasImages }) =>
			hasImages &&
			`
		max-width: 370px;
		margin-left: auto;
		margin-right: auto;
		`}
	}
`

const MapContainer = styled(Grid)`
	& > div {
		max-height: 300px;
		max-width: 600px;
		width: 100%;
	}
	.marker-root {
		width: auto;
		max-width: 75px;
	}
	${({ theme }) => theme.breakpoints.down('md')} {
		& > div {
			margin: auto;
		}
	}
`

const PhotoDescription = styled(Typography)`
	position: absolute;
	bottom: ${({ theme }) => `calc(${theme.spacing(5)} + 5.8%)`};
	left: 0;
	right: 0;
	text-align: center;
`

const Title = styled(Typography)`
	margin-bottom: ${({ theme }) => theme.spacing(5)};
`

const WorkingTimesRow = styled(Grid)`
	max-width: 370px;
	span {
		color: ${({ theme }) => theme.palette.primary.main};
	}
`

const WorkingTimes = styled(BHWorkingTimes)`
	display: grid;
	grid-template-columns: 1fr 2fr;
	gap: ${({ theme }) => theme.spacing(0.5)};
	> span {
		display: block;
		:first-of-type {
			font-family: ${({ theme }) => theme.typography.body2.fontFamily};
			font-weight: ${({ theme }) => theme.typography.body2.fontWeight};
		}
	}
`

const Root = styled('div')``

export {
	BackButton,
	Content,
	GetDirection,
	InnerContent,
	PhotoDescription,
	Title,
	WorkingTimesRow,
	WorkingTimes,
	Root,
	MapContainer,
}
